<template>
  <div class="_transfer-info-content">
    <TransferLineOfficialAccountMoveInfo />
    <TransferLineOfficialAccountNewInfo />
  </div>
</template>

<script>
import TransferLineOfficialAccountMoveInfo from '@/components/LineOfficialAccount/TransferLineOfficialAccountMoveInfo'
import TransferLineOfficialAccountNewInfo from '@/components/LineOfficialAccount/TransferLineOfficialAccountNewInfo'

export default {
  name: 'TransferLineOfficialAccountInformationContent',
  components: {
    TransferLineOfficialAccountMoveInfo,
    TransferLineOfficialAccountNewInfo
  }
}
</script>

<style lang="scss" scoped>
._transfer-info-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 400px;
  font-family: "Prompt", sans-serif;
}

/* Styles moved to individual components */
</style>
